import React from "react";
import type { FC } from 'react';
import logoPath from "./PulaSymbol.svg"
import './currencyStyles.css'
import { Typography } from "@mui/material";

interface PulaSymbolProps {
  [key: string]: any;
}

const PulaSymbol: FC<PulaSymbolProps> = (props) => {

  return (
    <h1
      // component="div"
      // sx={{
      //   fontSize: {
      //     lg: '2rem',
      //     md: '1.5rem',
      //     sm: '1rem',
      //     xs: '1rem'
      //   },
      //   fontWeight: 'bold'
      // }}
    >
      P
    </h1>
  );
};

export default PulaSymbol;